import IconActionEdit from '@uilib/assets-business-icons/IconActionEdit';
import IconActionDelete from '@uilib/assets-business-icons/IconActionDelete';

import i18n from 'Services/i18n';
import Filters from 'Services/Filters';

import HighlightBlank from 'Bricks/highlight-blank';
import { List } from 'Bricks/List';

import Spacer from '@uilib/core/Spacer/Spacer';
import FlexContainer from '@uilib/core/FlexContainer/FlexContainer';
import Link from 'uilib-wrappers/link';

import colors from 'eset-ui-colors';

function CommentList(props) {
    return props.comments.map((comment, index) => {
        const label = comment.lastEditTime
            ? i18n('USER_CREATED_LAST_EDIT', {
                  user: comment.authorName,
                  whenCreated: Filters.localDate(comment.creationTime),
                  whenEdited: Filters.localDate(comment.lastEditTime),
              })
            : i18n('USER_CREATED', {
                  user: comment.authorName,
                  whenCreated: Filters.localDate(comment.creationTime),
              });

        return (
            <List.Item highlightBlank={false} label={label}>
                <HighlightBlank value={comment.commentValue} />
                {props.userUuid === comment.authorUuid ? (
                    <div style={{ marginLeft: 'auto', 'flex-shrink': 0 }}>
                        <FlexContainer align="center" justify="center">
                            <Spacer type="mx-3">
                                <Link
                                    onClick={() => props.handleEditComment(comment.commentId, comment.commentValue)}
                                    icon={<IconActionEdit fill={colors.primary} disabled={props.disabled} />}
                                    text="EDIT"
                                    disabled={props.disabled}
                                />
                            </Spacer>
                            <Spacer type="mr-3">
                                <Link
                                    onClick={() => props.handleDeleteComment(comment.commentId)}
                                    icon={<IconActionDelete fill={colors.primary} disabled={props.disabled} />}
                                    text="DELETE"
                                    disabled={props.disabled}
                                />
                            </Spacer>
                        </FlexContainer>
                    </div>
                ) : null}
            </List.Item>
        );
    });
}

export default CommentList;
